module.exports = __webpack_public_path__ + "img/refresh-cw.4456b946.svg";